class HawkSearchTracking {
  readonly #queryIdName = 'query_id'
  readonly #visitIdName: string
  readonly #visitorIdName: string

  constructor(visitIdName = 'visit_id', visitorIdName = 'visitor_id') {
    this.#visitIdName = visitIdName
    this.#visitorIdName = visitorIdName
  }

  clearVisitId(): void {
    this.#setCookie(this.#visitIdName, '', 'Thu, 01 Jan 1970 00:00:01 GMT')
  }

  fetchOrGenerateQueryIdViaCookie(): string {
    let queryId = this.#getCookie(this.#queryIdName)
    if (!queryId) {
      queryId = this.#createUUID()
      this.#setCookie(this.#queryIdName, queryId)
    }
    return queryId
  }

  replaceQueryIdCookie(): string {
    const newQueryId = this.#createUUID()
    this.#setCookie(this.#queryIdName, newQueryId)
    return newQueryId
  }

  getVisitId(): string {
    const visitId = this.#getCookie(this.#visitIdName) ?? this.#createUUID()
    this.#setCookie(this.#visitIdName, visitId, this.#getVisitExpiry())
    return visitId
  }

  getVisitorId(): string {
    const visitorId = this.#getCookie(this.#visitorIdName) ?? this.#createUUID()
    this.#setCookie(this.#visitorIdName, visitorId, this.#getVisitorExpiry())
    return visitorId
  }

  setQueryIdOnCookie(value: string): void {
    this.#setCookie(this.#queryIdName, value)
  }

  #createUUID(): string {
    let d = new Date().getTime()
    const d2 = (performance?.now?.() ?? 0) * 1000
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
      const r =
        d > 0
          ? (d + Math.random() * 16) % 16 | 0
          : (d2 + Math.random() * 16) % 16 | 0
      d = d > 0 ? Math.floor(d / 16) : Math.floor(d2 / 16)
      return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16)
    })
  }

  #getCookie(name: string): string | null {
    return (
      document.cookie
        .split('; ')
        .find((row) => row.startsWith(name + '='))
        ?.split('=')[1] ?? null
    )
  }

  #getVisitExpiry(): string {
    return new Date(Date.now() + 4 * 60 * 60 * 1000).toUTCString()
  }

  #getVisitorExpiry(): string {
    return new Date(Date.now() + 360 * 24 * 60 * 60 * 1000).toUTCString()
  }

  #setCookie(name: string, value: string, expiry?: string): void {
    document.cookie = `${name}=${value}; expires=${expiry ?? ''}; path=/`
  }
}

export const hawkSearchTracking = new HawkSearchTracking()
